import { render } from "./MainNavbar.vue?vue&type=template&id=081e0bce&scoped=true"
import script from "./MainNavbar.vue?vue&type=script&lang=js"
export * from "./MainNavbar.vue?vue&type=script&lang=js"

import "./MainNavbar.vue?vue&type=style&index=0&id=081e0bce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-081e0bce"],['__file',"src/layouts/navbar/MainNavbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "081e0bce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('081e0bce', __exports__)) {
    api.reload('081e0bce', __exports__)
  }
  
  module.hot.accept("./MainNavbar.vue?vue&type=template&id=081e0bce&scoped=true", () => {
    api.rerender('081e0bce', render)
  })

}


export default __exports__